module.exports = __webpack_public_path__ + "assets/img/ic-g.35029bf6.svg";